import { useEffect, useMemo, useRef, useState } from "react";

import {
  getActiveTooltipPosition,
  getFeeScheduleChartColors,
  getFeeScheduleChartData,
  getFeeScheduleValues,
} from "../components/fee-schedule-calculator/helpers";
import { useSettlementStore } from "../store/settlementStore";

export default function useFeeScheduleCalculatorSection() {
  const sectionRef = useRef(null);
  const caseDetail = useSettlementStore((state) => state.caseDetail);
  const feeSchedule = useSettlementStore((state) => state.feeSchedule);
  const isFeeScheduleLoading = useSettlementStore((state) => state.isFeeScheduleLoading);
  const [hoveredSliceName, setHoveredSliceName] = useState(null);

  const values = useMemo(
    () => getFeeScheduleValues({ caseDetail, feeSchedule: feeSchedule ?? {} }),
    [caseDetail, feeSchedule]
  );
  const chartColors = useMemo(() => getFeeScheduleChartColors(), []);
  const chartData = useMemo(
    () => getFeeScheduleChartData(values, chartColors),
    [chartColors, values]
  );
  const activeSlice = hoveredSliceName
    ? chartData.find((item) => item.name === hoveredSliceName)
    : null;
  const activeIndex = chartData.findIndex((item) => item.name === hoveredSliceName);
  const activeTooltipPosition = activeSlice
    ? getActiveTooltipPosition(chartData, activeSlice.name)
    : undefined;

  useEffect(() => {
    const handleDocumentClick = (event) => {
      if (!sectionRef.current?.contains(event.target)) {
        setHoveredSliceName(null);
      }
    };

    document.addEventListener("mousedown", handleDocumentClick);
    return () => document.removeEventListener("mousedown", handleDocumentClick);
  }, []);

  return {
    sectionRef,
    values,
    chartColors,
    chartData,
    activeSlice,
    activeIndex,
    activeTooltipPosition,
    isFeeScheduleLoading,
    hoveredSliceName,
    setHoveredSliceName,
  };
}
